import { Outlet, createRootRoute } from "@tanstack/react-router";

import { AppShell, FullPageMessage } from "../components/layout";
import { useSession } from "../lib/session";
import { AccessPage } from "./access";
import { LoginPage } from "./login";

/**
 * Routing is code-based rather than file-based: the route tree is small, and generating a
 * `routeTree.gen.ts` would put a build artifact in the repository that reviewers cannot read as
 * the source of truth.
 *
 * The root decides between the login screen and the app: every other route assumes a session.
 */
export const rootRoute = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const session = useSession();
  // The mailed links (invitation, new password) work with or without a session.
  if (window.location.pathname === "/acceso") return <AccessPage />;
  if (session.isLoading) return null;
  if (session.error) {
    return (
      <FullPageMessage title="No pudimos conectar con el servidor.">
        Revisá tu conexión.
      </FullPageMessage>
    );
  }
  if (!session.data) return <LoginPage />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
